import { debounce } from 'lodash';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { setIsMobile } from '../../actions/configActions';

export default () => {
    const [width, setWidth] = useState<number>(window.innerWidth);
    const disaptch = useDispatch();

    const handleWindowSizeChange = debounce(() => {
        setWidth(window.innerWidth);
    }, 200);

    useEffect(() => {
        window.addEventListener('resize', handleWindowSizeChange);
        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        };
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        disaptch(setIsMobile(width <= 767));
        // eslint-disable-next-line
    }, [width]);

    return null;
};
